import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service';
import { IFormKey } from '../../models/forms';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { EPolicyStatus, EPolicyTypes, IPolicy, ISubject } from '../../models/policy.model';
import { BADGE_STYLE_PREFIX } from 'src/app/pages/search/search.constants';
import { IObjectKey } from '../../models/objects';
import { IAnagrafica } from 'src/app/modules/shared/components/ndg-variation/ndg-variation.constants';

@Component({
  selector: 'app-policy-card',
  templateUrl: './policy-card.component.html',
  styleUrl: './policy-card.component.scss',
})
export class PolicyCardComponent {

  @Input() item: IPolicy | ISubject | IAnagrafica | null = null;
  @Input() keys: IFormKey[] = [];
  @Input() title: string = '';
  @Input() showLogo: boolean = false;
  @Input() showBadge: boolean = false;
  @Input() showArrow: boolean = false;
  @Input() tooltip: string;
  @Input() showDeleteIcon: boolean = false;
  @Input() showVisibilityIcon: boolean = false;
  @Output() deleteCardCallback = new EventEmitter<any>();
  @Output() detailCardCallback = new EventEmitter<any>();
  @Output() actionRequested = new EventEmitter<IPolicy | ISubject | IAnagrafica>();

  hidePersonalData = false; // environment.name !== 'PROD';

  goTo() {
    LoggerService.logInfo(this.constructor.name, 'goTo', { item: this.item });
    if (this.showArrow) {
      this.actionRequested.emit(this.item);
    }
  }

  getPlaceholders(keysLength: number): number[] {
    const array = CommonUtils.getPlaceholders(keysLength, 5);
    return array;
  }

  getBadgeStyle(policyTypeRaw: EPolicyTypes): string {
    const policyType = policyTypeRaw as EPolicyTypes
    const type = policyType.toUpperCase();
    switch (type) {
      case EPolicyTypes.TCM:
      case EPolicyTypes.TCM_PPI:
        return BADGE_STYLE_PREFIX + EPolicyTypes.TCM.toLowerCase();
      case EPolicyTypes.FONDO_PENSIONE:
      case EPolicyTypes.PIP:
        return BADGE_STYLE_PREFIX + EPolicyTypes.FONDO_PENSIONE.toLowerCase().replace(' ', '-');
      case EPolicyTypes.TRADIZIONALE:
      case EPolicyTypes.PREVIDENZIALE:
      case EPolicyTypes.PREVIDENZIALI:
      case EPolicyTypes.MULTIRAMO:
      case EPolicyTypes.UNIT:
      case EPolicyTypes.LTC:
        return BADGE_STYLE_PREFIX + policyType.toLowerCase();
      default:
        return 'badge-disabled';
    }
  }

  getCompanyImage(itemRaw: IPolicy | ISubject | IAnagrafica): string {
    const item = itemRaw as IPolicy;
    if (item && item.companyId) {
      return CommonUtils.getCompanyImage(item.companyId);
    }
    return '';
  }

  getStatusBadgeStyle(policyStatus: string): string {
    return CommonUtils.getStatusBadgeStyle(policyStatus);
  }

  getValue(item: any, key: IObjectKey): string {
    const value = CommonUtils.getValueByPath(item, key);
    return value;
  }

  deleteCard(): void {
    LoggerService.logInfo(this.constructor.name, 'deleteCard');
    this.deleteCardCallback.emit();
  }

  detailCard(): void {
    LoggerService.logInfo(this.constructor.name, 'detailCard');
    this.actionRequested.emit();
  }

  get isCustomerCard(): boolean {
    return this.tooltip?.toLowerCase() === 'contraente';
  }

}
